var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',{staticClass:"mt-0 ml-1",attrs:{"label":_vm.title,"rules":_vm.rules,"readonly":_vm.readOnly},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('div',{domProps:{"textContent":_vm._s(_vm.title)}})]},proxy:true}]),model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }